module.exports = __webpack_public_path__ + "c63d7df60e839f55b6e880bb5c746937.svg";